import React, { createContext, useContext } from 'react';
import { LanguageContext } from '../LanguageProvider';
import { useIsLoggedIn } from '../../utils/hooks/useIsLoggedIn';
import { useShoppingCart } from '../../utils/hooks/useShoppingCart';
import { languages, languageToCode } from '../../utils/languageUtils';
export var LoginContext = /*#__PURE__*/createContext({});
export var ShoppingCartContext = /*#__PURE__*/createContext({});
var WebshopIntegrationProvider = function WebshopIntegrationProvider(_ref) {
  var children = _ref.children,
    targetSystem = _ref.targetSystem;
  var _useContext = useContext(LanguageContext),
    language = _useContext.language,
    erpSystem = _useContext.erpSystem;
  var _useIsLoggedIn = useIsLoggedIn({
      languageId: languages[language],
      erpSystem: erpSystem.toUpperCase(),
      targetSystem: targetSystem
    }),
    loggedIn = _useIsLoggedIn.loggedIn,
    loginUrl = _useIsLoggedIn.loginUrl,
    isGuestUser = _useIsLoggedIn.isGuestUser,
    loginLoading = _useIsLoggedIn.loginLoading,
    userType = _useIsLoggedIn.userType,
    userSegment = _useIsLoggedIn.userSegment,
    userId = _useIsLoggedIn.userId,
    customerNumber = _useIsLoggedIn.customerNumber,
    organizationName = _useIsLoggedIn.organizationName,
    userSalesChannel = _useIsLoggedIn.userSalesChannel;
  var _useShoppingCart = useShoppingCart({
      locale: languageToCode(language),
      erpSystem: erpSystem.toUpperCase(),
      targetSystem: targetSystem
    }),
    fetchShoppingCart = _useShoppingCart.fetchShoppingCart,
    shoppingCart = _useShoppingCart.shoppingCart,
    shoppingCartLoading = _useShoppingCart.shoppingCartLoading,
    shoppingCartError = _useShoppingCart.shoppingCartError;
  var loginContext = {
    loggedIn: loggedIn,
    isGuestUser: isGuestUser,
    loginUrl: loginUrl,
    userType: userType,
    userSegment: userSegment,
    userId: userId,
    customerNumber: customerNumber,
    organizationName: organizationName,
    userSalesChannel: userSalesChannel,
    loginLoading: loginLoading
  };
  var shoppingCartContext = {
    fetchShoppingCart: fetchShoppingCart,
    shoppingCart: shoppingCart,
    shoppingCartLoading: shoppingCartLoading,
    shoppingCartError: !!shoppingCartError
  };
  return /*#__PURE__*/React.createElement(LoginContext.Provider, {
    value: loginContext
  }, /*#__PURE__*/React.createElement(ShoppingCartContext.Provider, {
    value: shoppingCartContext
  }, children));
};
export default WebshopIntegrationProvider;